function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.05 16c.513 0 .936.386.993.883l.007.117-.001 1.05H21c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21 20.05h-1.951l.001.95c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L17.05 21l-.001-.95H3c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L3 18.05h14.049L17.05 17c0-.552.448-1 1-1zm-7-7c.513 0 .936.386.993.883l.007.117-.001 1.049L21 11.05c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21 13.05l-8.951-.001.001.951c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L10.05 14l-.001-.951L3 13.05c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L3 11.05l7.049-.001L10.05 10c0-.552.448-1 1-1zm-8-7c.513 0 .936.386.993.883L4.05 3l-.001 1.049L21 4.05c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L21 6.05 4.049 6.049 4.05 7c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L2.05 7V3c0-.552.448-1 1-1z"
});

var SvgSprite = function SvgSprite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSprite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sprite.073613a9.svg";
export { ForwardRef as ReactComponent };